import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.2434 2.58203L15.833 2.58203V3.81993C15.833 4.16659 15.833 4.99993 14.9997 4.99993H13.333C12.4825 4.99993 12.5486 4.16659 12.5486 3.81993V2.58203H7.49967V3.81993C7.49967 4.68449 7.51682 4.99993 6.66634 4.99993H4.99967C4.14919 4.99993 4.11895 4.68449 4.11895 3.81993V2.58203H2.76592C1.70282 2.58203 0.833008 3.46624 0.833008 4.54694V16.3954C0.833008 17.4761 1.70282 18.3603 2.76592 18.3603H17.2627C18.3258 18.3603 19.1957 17.4761 19.1957 16.3954V4.54694C19.1763 3.46624 18.3065 2.58203 17.2434 2.58203ZM17.8813 16.3954C17.8813 16.7491 17.5913 17.0438 17.2434 17.0438H2.74659C2.39866 17.0438 2.10873 16.7491 2.10873 16.3954V6.24993H17.9006V16.3954H17.8813Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.06437 10.833H5.93563C6.11527 10.833 6.25 10.6586 6.25 10.426V8.73998C6.25 8.50743 6.11527 8.33301 5.93563 8.33301H4.06437C3.88473 8.33301 3.75 8.50743 3.75 8.73998V10.426C3.75 10.6392 3.88473 10.833 4.06437 10.833Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.39738 10.833H9.26864C9.44828 10.833 9.58301 10.6586 9.58301 10.426V8.73998C9.58301 8.50743 9.44828 8.33301 9.26864 8.33301H7.39738C7.21774 8.33301 7.08301 8.50743 7.08301 8.73998V10.426C7.08301 10.6392 7.21774 10.833 7.39738 10.833Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7314 10.833H12.6026C12.7823 10.833 12.917 10.6586 12.917 10.426V8.73998C12.917 8.50743 12.7823 8.33301 12.6026 8.33301H10.7314C10.5517 8.33301 10.417 8.50743 10.417 8.73998V10.426C10.417 10.6392 10.5517 10.833 10.7314 10.833Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0644 10.833H15.9356C16.1153 10.833 16.25 10.6586 16.25 10.426V8.73998C16.25 8.50743 16.1153 8.33301 15.9356 8.33301H14.0644C13.8847 8.33301 13.75 8.50743 13.75 8.73998V10.426C13.75 10.6392 13.8847 10.833 14.0644 10.833Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.06437 15H5.93563C6.11527 15 6.25 14.8256 6.25 14.593V12.907C6.25 12.6744 6.11527 12.5 5.93563 12.5H4.06437C3.88473 12.5 3.75 12.6744 3.75 12.907V14.593C3.75 14.8062 3.88473 15 4.06437 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.39738 15H9.26864C9.44828 15 9.58301 14.8256 9.58301 14.593V12.907C9.58301 12.6744 9.44828 12.5 9.26864 12.5H7.39738C7.21774 12.5 7.08301 12.6744 7.08301 12.907V14.593C7.08301 14.8062 7.21774 15 7.39738 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7314 15H12.6026C12.7823 15 12.917 14.8256 12.917 14.593V12.907C12.917 12.6744 12.7823 12.5 12.6026 12.5H10.7314C10.5517 12.5 10.417 12.6744 10.417 12.907V14.593C10.417 14.8062 10.5517 15 10.7314 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0644 15H15.9356C16.1153 15 16.25 14.8256 16.25 14.593V12.907C16.25 12.6744 16.1153 12.5 15.9356 12.5H14.0644C13.8847 12.5 13.75 12.6744 13.75 12.907V14.593C13.75 14.8062 13.8847 15 14.0644 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.42832 4.16634H6.23914C6.47502 4.16634 6.66667 3.92693 6.66667 3.63227V1.36708C6.66667 1.07242 6.47502 0.833008 6.23914 0.833008H5.42832C5.19245 0.833008 5.0008 1.07242 5.0008 1.36708V3.63227C4.98605 3.92693 5.1777 4.16634 5.42832 4.16634Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7607 4.16634H14.5719C14.8079 4.16634 14.9997 3.92693 14.9997 3.63227V1.36708C14.9997 1.07242 14.8079 0.833008 14.5719 0.833008H13.7607C13.5247 0.833008 13.333 1.07242 13.333 1.36708V3.63227C13.333 3.92693 13.5247 4.16634 13.7607 4.16634Z",
			fill: "currentColor"
		})
	]
});
export default SvgCalendar;
